/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { IAudienceMultiplier } from "."
 */

const defaultAudienceMultiplier = 1;

/**
 * @implements {IAudienceMultiplier}
 */
export default class DefaultAudienceMultiplier {
  /** @type {IAudienceMultiplier['get']} */
  async get() {
    return await defaultAudienceMultiplier;
  }
}
